/**
 * Roles a partner admin may see, filter by, and be viewed as, as indexed in
 * `employees_nested.jurisdictions_keyword` (Rails ENUM KEYS, not the
 * `RelationshipType.*` column values). Labels live at `people.jurisdictions.<KEY>`.
 *
 * TIO-internal roles are absent: every RelationshipType carrying
 * `is_tio_employee` in its enum meta describes Tuition.io staff, not the
 * partner's own people. TAS_PROGRAM_ADMIN is the one exception -- it carries the
 * flag but is held by partner-side people in practice, so it stays until that
 * contradiction is settled.
 *
 * One list, because every surface that filters people by partner role has to
 * agree: the /people roles rail, its facet buckets, and the view-as picker.
 */
export const PARTNER_VISIBLE_ROLE_KEYS = [
  'ACCOUNT_OWNER',
  'EMPLOYEE_ADMIN',
  'PSLF_ADMIN',
  'PSLF_GROUP_APPROVER',
  'SUPERVISOR',
  'DEPARTMENT_HEAD',
  'TAS_APPROVER',
  'TAS_ADMIN_APPROVER',
  'TAS_CUSTOM_APPROVER',
  'TAS_CUSTOM_INDIVIDUAL_APPROVER',
  'TAS_FINANCE_APPROVER',
  'TAS_PROGRAM_ADMIN',
  'TAS_TAP_FINANCE_APPROVER',
  'TAS_PPP_FINANCE_APPROVER',
];
